/* ============================================================
   Cart drawer — JS original (Stratégie 2)
   Ouverture/fermeture + maj quantité/suppression en AJAX
   via Section Rendering API (le Liquid reste la source de vérité)
   ============================================================ */
(function () {
  'use strict';

  var SECTION = 'header';

  function init() {
    var cart = document.querySelector('[data-lf-cart]');
    if (!cart) return;

    var openers = document.querySelectorAll('[data-lf-cart-open]');
    var closers = cart.querySelectorAll('[data-lf-cart-close]');

    /* Le focus est confie a `lfCalque` : il reste dans le tiroir tant qu'il
       est ouvert, et revient a la fermeture sur ce qui l'a ouvert. L'ajout
       au panier transmet son bouton dans `detail.retour` — au moment ou
       l'evenement arrive, l'element actif n'est plus le bouton. */
    function open(e) {
      if (e && e.preventDefault) e.preventDefault();
      cart.classList.add('is-open');
      cart.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (window.lfCalque) {
        window.lfCalque.ouvrir(cart, {
          focus: cart.querySelector('.lf-cart__close'),
          retour: e && e.detail && e.detail.retour
        });
      }
      if (e && e.detail && e.detail.ligne) erreurLigne(e.detail.ligne.cle, e.detail.ligne.texte);
    }
    function close() {
      cart.classList.remove('is-open');
      cart.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (window.lfCalque) window.lfCalque.fermer(cart);
    }

    openers.forEach(function (o) { o.addEventListener('click', open); });
    closers.forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cart.classList.contains('is-open')) close();
    });

    cart.setAttribute('data-bound', '1');
    bindItems(cart);

    // Permettre l'ouverture depuis un évènement global (ajout produit futur)
    document.addEventListener('lf:cart:open', open);

    // Rendu de l'en-tete recu ailleurs (page panier) : le tiroir se met a jour.
    document.addEventListener('lf:cart:section', function (e) {
      if (!e.detail || !e.detail.html) return;
      var doc = new DOMParser().parseFromString(e.detail.html, 'text/html');
      var compte = doc.querySelector('[data-lf-cart-count]');
      render(e.detail.html, compte ? parseInt(compte.textContent, 10) || 0 : 0);
    });
  }

  function bindItems(cart) {
    cart.addEventListener('click', function (e) {
      var up = e.target.closest('[data-lf-qty-up]');
      var down = e.target.closest('[data-lf-qty-down]');
      var remove = e.target.closest('[data-lf-cart-remove]');

      if (remove) {
        e.preventDefault();
        changeQty(remove.dataset.key, 0);
      } else if (up || down) {
        e.preventDefault();
        var wrap = (up || down).closest('[data-lf-qty]');
        var input = wrap.querySelector('[data-lf-qty-input]');
        var current = parseInt(input.value, 10) || 0;
        var next = up ? current + 1 : Math.max(0, current - 1);
        changeQty(input.dataset.key, next);
      }
    });

    /* Entree dans un champ de quantite soumettait le formulaire du tiroir :
       la page partait vers /cart. On valide la quantite sur place. */
    cart.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('[data-lf-qty-input]')) return;
      e.preventDefault();
      e.target.dispatchEvent(new Event('change', { bubbles: true }));
    });

    cart.addEventListener('change', function (e) {
      var input = e.target.closest('[data-lf-qty-input]');
      if (!input) return;
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 1;
      changeQty(input.dataset.key, q);
    });
  }

  /* Message lisible depuis une reponse d'erreur de l'API panier : un
     texte, une liste, ou un objet { champ: [messages] }. */
  function texteErreur(data) {
    var brut = data && (data.description || data.errors || data.message);
    var repli = (window.lfStrings || {}).cartUpdateError || '';
    if (!brut) return repli;
    if (typeof brut === 'string') return brut;
    if (Array.isArray(brut)) return brut.join(' ');
    return Object.keys(brut).map(function (k) { return [].concat(brut[k]).join(' '); }).join(' ') || repli;
  }

  function erreurLigne(key, texte) {
    var lignes = document.querySelectorAll('[data-lf-cart] [data-lf-cart-item]');
    for (var i = 0; i < lignes.length; i++) {
      if (lignes[i].dataset.key !== key) continue;
      var zone = lignes[i].querySelector('[data-lf-line-error]');
      if (zone) zone.textContent = texte || '';
      return;
    }
  }

  function changeQty(key, quantity) {
    var cart = document.querySelector('[data-lf-cart]');
    cart.classList.add('is-loading');

    fetch(window.lfRoutes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        var data = res.data;
        /* Au-dela du stock, l'API repond 422 sans rendu de section. Rien
           n'etait remplace : le champ gardait la quantite demandee, le total
           restait l'ancien, et aucun message ne s'affichait. On relit le
           panier tel que le serveur l'a garde, puis on dit pourquoi. */
        if (!res.ok || data.status) {
          return rafraichir().then(function () { erreurLigne(key, texteErreur(data)); });
        }
        if (data.sections && data.sections[SECTION]) {
          render(data.sections[SECTION], data.item_count);
        }
        // Le serveur peut aussi plafonner la quantite sans erreur.
        var ligne = (data.items || []).filter(function (it) { return it.key === key; })[0];
        if (quantity > 0 && ligne && ligne.quantity < quantity) {
          var modele = (window.lfStrings || {}).cartQuantityError || '';
          erreurLigne(key, modele.replace('[quantity]', ligne.quantity));
        }
      })
      .catch(function () {
        erreurLigne(key, (window.lfStrings || {}).cartUpdateError || '');
      })
      .then(function () {
        cart.classList.remove('is-loading');
      });
  }

  function rafraichir() {
    var racine = (window.lfRoutes && window.lfRoutes.root) || '/';
    return Promise.all([
      fetch(racine + (racine.slice(-1) === '/' ? '' : '/') + '?section_id=' + SECTION).then(function (r) { return r.text(); }),
      fetch(window.lfRoutes.cart + '.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      render(res[0], res[1].item_count);
    });
  }

  /* Le corps du tiroir est remplace a chaque changement de quantite : le
     bouton qui avait le focus disparait avec lui, et le focus retombait
     sur `body`. On note ce qui etait focalise — quelle commande, sur
     quelle ligne — pour le retrouver dans le nouveau rendu. */
  var ROLES = ['data-lf-qty-down', 'data-lf-qty-up', 'data-lf-qty-input', 'data-lf-cart-remove'];

  function decrireFocus() {
    var cart = document.querySelector('[data-lf-cart]');
    var actif = document.activeElement;
    if (!cart || !actif || !cart.contains(actif)) return null;
    var ligne = actif.closest('[data-lf-cart-item]');
    for (var i = 0; i < ROLES.length; i++) {
      if (actif.hasAttribute(ROLES[i]) && ligne) return { role: ROLES[i], cle: ligne.dataset.key };
    }
    return { role: null };
  }

  function retablirFocus(description) {
    if (!description) return;
    var cart = document.querySelector('[data-lf-cart]');
    if (!cart) return;
    var cible = null;
    if (description.role) {
      var lignes = cart.querySelectorAll('[data-lf-cart-item]');
      for (var i = 0; i < lignes.length; i++) {
        if (lignes[i].dataset.key === description.cle) {
          cible = lignes[i].querySelector('[' + description.role + ']');
          break;
        }
      }
    }
    // Ligne supprimee : le focus rejoint le bouton de fermeture.
    if (!cible) cible = cart.querySelector('.lf-cart__close');
    if (cible) cible.focus({ preventScroll: true });
  }

  function render(html, itemCount) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var focus = decrireFocus();

    swap('[data-lf-cart-body]', doc);
    swap('[data-lf-cart-foot]', doc);
    swap('[data-lf-cart-head-count]', doc);
    retablirFocus(focus);

    // compteur de l'icône header
    var count = document.querySelector('[data-lf-cart-count]');
    if (count) {
      count.textContent = itemCount;
      count.classList.toggle('is-empty', itemCount === 0);
    }
  }

  function swap(selector, doc) {
    var fresh = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (fresh && current) current.replaceWith(fresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
